import React, {useState} from "react";
import styled from "styled-components";
import pool1 from '../../assets/images/pool1.jpg';
import pool2 from '../../assets/images/pool2.jpg';
import summer1 from '../../assets/images/summer1.jpg';
import summer2 from '../../assets/images/summer2.jpg';
import rental1 from '../../assets/images/rental1.jpg';
import rental2 from '../../assets/images/rental2.jpg';
import amenity1 from '../../assets/images/amenity1.jpg';
import amenity2 from '../../assets/images/amenity2.jpg';
import amenity3 from '../../assets/images/amenity3.jpg';
import amenity4 from '../../assets/images/amenity4..jpg';
import amenity5 from '../../assets/images/amenity5.jpg';
import amenity6 from '../../assets/images/amenity6.jpg';
import amenity7 from '../../assets/images/amenity7.jpg';
import amenity8 from '../../assets/images/amenity8.jpg';
import field1 from '../../assets/images/field1.jpg';
import field2 from '../../assets/images/field2.jpg';
import terrace1 from '../../assets/images/terrace1.jpg';
import terrace2 from '../../assets/images/terrace2.jpg';
import PageHeader from "../../components/organisms/PageHeader";
import LeftSection from "../../components/organisms/LeftSection";
import RightSection from "../../components/organisms/RightSection";
import Modal from "../../components/organisms/Modal";
import facilityData from "../../data/menu2/naturePoolFacilityData.json";
import {device} from "../../assets/styles/media.js";

const Content = styled.div`
    margin-top: 15px;

    p {
        font-size: 18px;
        line-height: 1.56;
        white-space: pre-wrap;
        color: #ed8e0c;
        letter-spacing: -0.45px;
    }

    ${device.tablet} {
        p {
            white-space: initial;
        }
    }

    ${device.mobile} {
        p {
            font-size: 14px;
            white-space: initial;
        }
    }
`;
const SubTitle = styled.p`
    margin-bottom: 20px;
    font-weight: bold;
    font-size: 20px;
    letter-spacing: 0;

    ${device.mobile} {
        font-size: 16px;
    }
`;
const Desc = styled.p`
    color: #4a4a4a;
    font-size: 18px;
    line-height: 1.56;
    ${device.mobile} {
        font-size: 14px;
        //white-space: pre;
    }
`;
const List = styled.ul`
    margin-top: 27px;`;
const Item = styled.li`
    padding-top: 10px;
    color: #4a4a4a;
    font-size: 18px;
    line-height: 1.56;

    span {
        font-size: 18px;
        display: inline-block;
        color: #ed8e0c;
        width: 43px;
    }

    ${device.mobile} {
        font-size: 14px;
        white-space: break-spaces;
        span {
            font-size: 14px;
        }
    }
`;
const PopupBtn = styled.div`
    position: absolute;
    top: 315px;
    left: 860px;
    width: 152px;
    height: 33px;
    cursor: pointer;
`;


const NaturePoolFacility = () => {
    const [openModal, setOpenModal] = useState(false);
    const {textList, yellowList, amenitiesTextList} = facilityData;

    const openWaterPopup = (e) => {
        e.preventDefault();
        setOpenModal(true);
    };

    const navList = [
        {name: "수영장&카페, 여름&대여시설", link: "#"},
        {name: "수영장 수질 관리", open: openWaterPopup},
        {name: "편의시설 & 먹거리", link: "#amenitiy"},
        {name: "운동장", link: "#field"},
    ];
    return (
        <>
                <PageHeader
                    bTitle="관람"
                    subTitle="네이처풀"
                    detail="시설안내"
                    desc="강아지숲 네이처풀 시설을 안내해 드립니다."
                    list={navList}
                    link={true}

                />
                <PopupBtn
                    onClick={() => setOpenModal(true)}
                />
                {/*section 1*/}
                <LeftSection
                    title="네이처풀 수영장"
                    enTitle="Naturepool"
                    textList={textList[0]}
                    content={<Content>{yellowList[0].map(el => (<p>{el}</p>))}</Content>}
                    img1={pool1}
                    img2={pool2}
                />

                {/*section 2*/}
                <RightSection
                    title="카페, 여름"
                    enTitle="Café, Summer"
                    textList={textList[1]}
                    content={<Content>{yellowList[1].map(el => (<p>{el}</p>))}</Content>}
                    img1={summer1}
                    img2={summer2}
                />

                {/*section 3*/}
                <LeftSection
                    title="대여시설"
                    enTitle="Swim Gear Rental"
                    content={
                        <>
                            <SubTitle>방갈로/썬베드/파라솔</SubTitle>
                            <Desc>하늘 위로 드리워진 흰 차양막이 프라이빗한 분위기를 조성해줍니다.</Desc>
                            <Desc>열대 지역의 휴양지를 연상시키는 공간에서는 휴식이 주는 편안함을 누리며 지친</Desc>
                            <Desc>몸과 마음을 다독일 수 있습니다.</Desc>
                        </>
                    }
                    img1={rental1}
                    img2={rental2}
                    simbol={true}
                    simbolId={"amenitiy"}
                />

                {/*section 4*/}
                <RightSection
                    title="편의시설"
                    enTitle="Amenities"
                    textList={amenitiesTextList}
                    img1={amenity1}
                    img2={amenity2}
                    content={
                        <List>
                            <Item><span>B1F</span>샤워실(남/여)</Item>
                            <Item><span>1F</span>네이처 푸드테라스, 라커룸 & 탈의실, 강아지 목욕실 & 드라이실</Item>
                            <Item><span>2F</span>컨퍼런스룸</Item>
                        </List>
                    }
                />

                {/*section 5*/}
                <LeftSection
                    title="편의시설 - B1 F"
                    enTitle="Amenities"
                    content={
                        <>
                            <SubTitle>샤워실(남/여)</SubTitle>
                            <Desc>물놀이 전후의 청결을 책임지는 공간입니다.</Desc>
                            <Desc>기본 샤워시설이 갖춰져 있습니다.</Desc>
                            <Content>
                                {/*<p>25년 시즌 종료, 26년 운영 예정</p>*/}
                                <p>샴푸 및 바디워시 등 일부 목욕용품 비치</p>
                                <p>(미드시즌) 운영 시간 : 10:00 ~ 17:30</p>
                                <p>(하이시즌) 운영 시간 : 10:00 ~ 20:30</p>

                            </Content>
                        </>
                    }
                    img1={amenity3}

                    img2={amenity4}
                />

                {/*section 6*/}
                <RightSection
                    title="편의시설 - 1 F"
                    enTitle="Amenities"
                    content={
                        <>
                            <SubTitle>라커룸&탈의실(남/여)</SubTitle>
                            <Desc>수영장 이용 전, 물품을 보관하고 수영복으로 갈아입을 수 있습니다.</Desc>
                            <Content>
                                {/*<p>25년 시즌 종료, 26년 운영 예정</p>*/}
                                <p>(미드시즌) 운영 시간 : 10:00 ~ 17:30</p>
                                <p>(하이시즌) 운영 시간 : 10:00 ~ 20:30</p>

                            </Content>
                        </>
                    }

                    img1={amenity5}
                    img2={amenity6}
                />

                {/*section 7*/}
                <LeftSection
                    title="편의시설 - 1 F"
                    enTitle="Amenities"
                    content={
                        <>
                            <SubTitle>강아지 목욕실&드라이실</SubTitle>
                            <Desc>반려견이 보송보송한 기분으로 집으로</Desc>
                            <Desc>갈 수 있게 해줍니다.</Desc>
                            <Content>
                                {/*<p>25년 시즌 종료, 26년 운영 예정</p>*/}
                                <p>(미드시즌) 운영 시간 : 10:00 ~ 17:30</p>
                                <p>(하이시즌) 운영 시간 : 10:00 ~ 20:30</p>
                                <p>이용 요금 무료 (수영장 이용 고객만 이용 가능)</p>
                                <p>강아지 목욕용품의 경우, 따로 비치되어 있지 않아</p>
                                <p>카페, 여름에서 구매하시거나 챙겨오셔야 합니다.</p>
                            </Content>
                        </>
                    }
                    img1={amenity7}
                    img2={amenity8}
                />

                {/*section 8*/}
                <RightSection
                    title="먹거리 - 1 F"
                    enTitle="Nature Food Terrace"
                    content={
                        <>
                            <SubTitle>네이처 푸드테라스</SubTitle>
                            <Desc>자연을 벗삼은 공간에 신선하고</Desc>
                            <Desc>건강한 별미들이 준비되어 있습니다.</Desc>
                            <Content>
                                <p>(미드시즌) 운영 시간 : 11:00 ~ 18:00(주문 마감: 17:00)</p>
                                <p>(하이시즌) 운영 시간 : 11:00 ~ 20:00(주문 마감: 19:30)</p>
                            </Content>
                        </>
                    }
                    top={"285px"}
                    img1={terrace1}
                    img2={terrace2}
                    simbol={true}
                    simbolId={"field"}
                />

                {/*section 9*/}
                <LeftSection
                    title="네이처풀 운동장"
                    enTitle="Naturepool Field"
                    content={
                        <>
                            <Desc>반려견에게 수영장에서의 물놀이로 시원함을 안겨 주었다면,</Desc>
                            <Desc>따뜻한 햇볕이 스며드는 네이처풀 운동장에서도 원없이 뛰도록 해주세요.</Desc>
                            <br/>
                            <Desc>시원함과 따뜻함이 공존하는 이곳은 반려견에겐</Desc>
                            <Desc>보호자와 가장 행복한 시간을 보낸, 잊지못할 장소로 기억될 것입니다.</Desc>
                        </>
                    }
                    img1={field1}
                    img2={field2}
                />

            {openModal &&
                <Modal
                    img={true}
                    open={openModal}
                    width={"800px"}
                    setOpenModal={setOpenModal}
                />
            }
        </>
    );
};

export default NaturePoolFacility;
